<template>
    <div class="content">
        <div class="person">
            <div class="perInformation">
                <div style="margin-left: .475rem;">
                    <img src="../../assets/newImg/person.png" alt=""
                        style="margin-top: .2875rem;vertical-align: top;width: .5625rem;height: .5625rem;">
                    <span
                        style="font-size: .25rem;font-family: PingFang SC, PingFang SC;font-weight: bold;color: #333333;margin-left: .25rem;vertical-align: middle;">{{
                            userName }}，欢迎您！</span>
                </div>
                <div style="margin-right: .2rem;" v-if="isInfo == 1 || plantInfo == 1">
                    <span style="cursor:pointer;width: 5rem;display: inline-block;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-size: .2rem;font-family: PingFang SC, PingFang SC;font-weight: bold;vertical-align: middle;color: #333333;margin-right: .3625rem
                        ">
                        
                        <el-tooltip class="box-item" effect="dark" :content="$t('meg.identity')"
                            placement="top">
                            {{ $t('meg.identity') }}
                        </el-tooltip>
                    </span>
                    <el-button class="kehuBtn" @click="kehuBtn" v-if="roleType == 1 && isInfo != 2">{{
                            $t('meg.Certified') }}</el-button>

                    <el-button class="facAuth" @click="facBtn" v-if="roleType == 2 && plantInfo != 2">{{
                            $t('meg.Certifieman') }}</el-button>

                </div>
                <el-button class="kehuBtn" disabled style="margin-right: .2625rem;margin-top: .25rem;"
                    v-if="isInfo == 2 || plantInfo == 2">{{ $t('meg.Review') }}</el-button>
                <!-- <el-button class="kehuBtn" v-if="isInfo == 0 || plantInfo != 0"
                    style="margin-right: 21px;margin-top: 20px;">开始下单</el-button> -->
            </div>
            <ul class="liBox">
                <li :class="{ active: tabIndex == 1 || tabIndex == '' }" @click="personBtn(1)">{{ $t('meg.personal') }}
                </li>
                <li :class="{ active: tabIndex == 2 }" @click="personBtn(2)">{{ $t('meg.myOrder') }}</li>
                <li :class="{ active: tabIndex == 3 }" @click="personBtn(3)">{{ $t('meg.MyCollection') }}</li>
                <li :class="{ active: tabIndex == 4 }" @click="personBtn(4)">{{ $t('meg.message') }}</li>
            </ul>
            <hr style="margin: .2625rem .2875rem 0 .325rem;border: .0125rem solid #DDDDDD;">
            <informationVue v-if="tabIndex == 1 || tabIndex == ''" @childEvent="childEvent" />
            <orderListVue v-if="tabIndex == 2" />
            <myCollectVue v-if="tabIndex == 3" />
            <messageVue v-if="tabIndex == 4" />

            <div>
                <el-dialog v-model="kefuDialog" width="12.25rem" :before-close="handleClose"
                    style="padding-bottom: .375rem;">
                    <h1
                        style="margin-left: .4875rem; text-align: left; font-size: .3rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #000000;">
                        {{ $t('meg.ImproveInformation') }}</h1>
                    <div>
                        <el-form :inline="true" label-width="1.875rem" :model="authForm" class="demo-form-inline">
                            <el-form-item :label="$t('meg.Company')" required>
                                <el-input v-model="authForm.companyName" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.address')" required>
                                <el-input v-model="authForm.companyAddress" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.Establishment')" required>
                                <el-date-picker v-model="authForm.establishedTime" type="date" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.Number')" required>
                                <el-input-number type="number" v-model="authForm.staffNumber" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.Business')" required>
                                <el-select multiple placeholder="请选择" v-model="authForm.businessType" clearable>
                                    <el-option label="品牌" value="1" />
                                    <el-option label="工厂" value="2" />
                                    <el-option label="个体经营" value="3" />
                                    <el-option label="工贸一体" value="4" />
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="$t('meg.ProductType')" required>
                                <el-input v-model="authForm.productType" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.saleType')" required>
                                <el-select multiple placeholder="请选择" v-model="authForm.marketType" clearable>
                                    <el-option label="批发" value="1" />
                                    <el-option label="零售" value="2" />
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="$t('meg.distribution')" required>
                                <el-select multiple placeholder="请选择" v-model="authForm.marketChannel" clearable>
                                    <el-option label="实体店" value="1" />
                                    <el-option label="网销平台" value="2" />
                                    <el-option label="其他" value="3" />
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="$t('meg.annual')" required>
                                <el-input v-model="authForm.annualSalesNum" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.revenue')" required>
                                <el-input v-model="authForm.annualSales" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.processing')" required>
                                <el-select multiple placeholder="请选择" v-model="authForm.desiredProcessingMode"
                                    clearable>
                                    <el-option label="FOB" value="1" />
                                    <el-option label="ODM" value="2" />
                                    <el-option label="OEM" value="3" />
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="$t('meg.markets')" required>
                                <el-input v-model="authForm.principalMarket" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.contact')" required>
                                <el-input v-model="authForm.businessContact" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.Position')" required>
                                <el-input v-model="authForm.businessContactDuty" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.information')" required>
                                <el-input v-model="authForm.businessContactPhone" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.Profile')" required>
                                <el-input v-model="authForm.briefIntroduction" clearable style="width: 8.75rem;" />
                            </el-form-item>
                            <el-form-item :label="$t('meg.license')" required>
                                <el-upload v-mode="authForm.businessLicense" class="upload-demo" :action="uploadUrl"
                                    :headers="{ Authorization: acctoken }" ref="upload" :limit="1"
                                    :on-success="orderContractSuccess" :before-upload="beforeImageUpload"
                                    :on-exceed="handleExceed" :on-error="handleError" accept="image/jpeg,image/png">
                                    <el-button class="uploadBtn">{{ $t('meg.upload') }}</el-button>
                                    <p
                                        style="font-size: .175rem;font-family: PingFang SC, PingFang SC;font-weight: 500;color: #777777;margin-left: .125rem;">
                                        {{ $t('meg.uploaded') }}</p>
                                </el-upload>
                            </el-form-item>
                        </el-form>
                        <el-button class="shenqingBtn" @click="clientAuth">{{ $t('meg.Applying') }}</el-button>
                    </div>
                </el-dialog>
            </div>
            <div>
                <el-dialog v-model="factoryDialog" width="12.25rem" :before-close="handleClose"
                    style="padding-bottom: .375rem;">
                    <h1
                        style="margin-left: .4875rem; text-align: left; font-size: .3rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #000000;">
                        {{ $t('meg.ImproveInformation') }}</h1>
                    <div>
                        <el-form :inline="true" label-width="1.875rem" :model="facForm" class="demo-form-inline">
                            <el-form-item :label="$t('meg.Company')" required>
                                <el-input v-model="facForm.plantName" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.address')" required>
                                <el-input v-model="facForm.plantAddress" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.Establishment')" required>
                                <el-date-picker v-model="facForm.establishedTime" type="date" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.Number')" required style="margin-left: .3rem;">
                                {{ totalStaffNumber }}
                            </el-form-item>
                            <div style="display: flex;flex-wrap: wrap;">
                                <el-form-item :label="$t('meg.cutNum')" required>
                                    <el-input-number v-model="facForm.tailorNum" clearable />
                                </el-form-item>
                                <el-form-item :label="$t('meg.sewing')" required style="width: 50%;">
                                    <el-input-number v-model="facForm.workNum" clearable />
                                </el-form-item>
                                <el-form-item :label="$t('meg.packaging')" required>
                                    <el-input-number v-model="facForm.packagingNum" clearable />
                                </el-form-item>
                                <el-form-item :label="$t('meg.quality')" required>
                                    <el-input-number v-model="facForm.qualityNum" clearable />
                                </el-form-item>
                            </div>
                            <el-form-item :label="$t('meg.plantArea')" required>
                                <el-input v-model="facForm.plantArea" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.lines')" required>
                                <el-input v-model="facForm.productionLineNum" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.category')" required>
                                <el-input v-model="facForm.processingCategory" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.output')" required>
                                <el-input v-model="facForm.annualSalesNum" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.value')" required>
                                <el-input v-model="facForm.annualSales" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.orderType')" required>
                                <el-select multiple v-model="facForm.orderType" placeholder="请选择" clearable>
                                    <el-option label="FOB" value="1" />
                                    <el-option label="ODM" value="2" />
                                    <el-option label="OEM" value="3" />
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="$t('meg.markets')" required>
                                <el-input v-model="facForm.principalMarket" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.contact')" required>
                                <el-input v-model="facForm.businessContact" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.contactPhone')" required>
                                <el-input v-model="facForm.businessContactPhone" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.ContactEmail')">
                                <el-input v-model="facForm.businessContactEmail" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.ContactWeChat')">
                                <el-input v-model="facForm.businessContactWx" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.ContactQQ')">
                                <el-input v-model="facForm.businessContactQq" clearable />
                            </el-form-item>
                            <el-form-item :label="$t('meg.Profile')" required>
                                <el-input v-model="facForm.plantIntroduce" clearable style="width: 8.75rem;" />
                            </el-form-item>
                            <el-form-item :label="$t('meg.license')" required>
                                <el-upload v-mode="facForm.businessLicense" class="upload-demo" :action="uploadUrl"
                                    :headers="{ Authorization: acctoken }" ref="upload" :limit="1"
                                    :on-success="handleSuccess" :before-upload="beforeImageUpload"
                                    :on-exceed="handleExceed" :on-error="handleError" accept="image/jpeg,image/png">
                                    <el-button class="uploadBtn">{{ $t('meg.upload') }}</el-button>
                                    <p
                                        style="font-size: .175rem;font-family: PingFang SC, PingFang SC;font-weight: 500;color: #777777;margin-left: .125rem;">
                                        {{ $t('meg.uploaded') }}</p>
                                </el-upload>
                            </el-form-item>
                        </el-form>
                        <el-form>
                            <el-form-item :label="$t('meg.facImg')" required style="margin-left: .9375rem;">
                                <el-upload v-model="facForm.picture" class="upload-demo" :action="uploadUrl" :limit="10"
                                    :on-exceed="handleImgExceed" :headers="{ Authorization: acctoken }" ref="upload"
                                    :on-preview="handlePictureCardPreview" :on-success="handleImgSuccess"
                                    :on-remove="handleRemove" :before-upload="beforeImageUpload"
                                    accept="image/jpeg,image/png" list-type="picture-card">
                                    <!-- <el-button class="uploadBtn">{{$t('meg.upload')}}</el-button> -->
                                    <p
                                        style="font-size: .175rem;font-family: PingFang SC, PingFang SC;font-weight: 500;color: #777777;margin-left: .125rem;">
                                        {{ $t('meg.uploaded') }}</p>
                                </el-upload>
                                <el-dialog v-model="dialogVisible">
                                    <img :src="dialogImageUrl" alt="" style="width: 80%;height: 100%;" />
                                </el-dialog>
                            </el-form-item>
                        </el-form>
                        <el-button class="shenqingBtn" @click="facAuth">{{ $t('meg.Applying') }}</el-button>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, reactive, ref, computed } from 'vue'
import { completeInformation, plantInformation } from "@/api/person.js"
import { ElMessage } from 'element-plus'
import informationVue from './components/information.vue'
import myCollectVue from './components/myCollect.vue'
import orderListVue from './components/orderList.vue'
import messageVue from './components/message.vue'
import { useRoute } from 'vue-router'
const tabIndex = ref(localStorage.getItem("type"))
const roleType = localStorage.getItem("roleType")
const kefuDialog = ref(false)
const factoryDialog = ref(false)
const dialogVisible = ref(false)
const isInfo = ref("")
const plantInfo = ref("")
const dialogImageUrl = ref("")
const type = ref(localStorage.getItem("type"))
// const route = useRoute()
const userName = localStorage.getItem("userName")
const acctoken = ref(localStorage.getItem("access_token"))
const uploadUrl = ref('/dev-api' + '/file/upload')
const personBtn = (index) => {
    tabIndex.value = index
}

// 计算员工数量
const totalStaffNumber = computed(() => {
    return facForm.tailorNum + facForm.workNum + facForm.packagingNum + facForm.qualityNum;
});

// onMounted(() => {
//     type.value = route.query.type
// })

const childEvent = (data) => {

    // 根据 roleType 进行操作
    if (data.roleType == 1) {
        // 处理客户的逻辑，使用 clientList
        isInfo.value = data.clientList.isInfo
    } else if (data.roleType == 2) {
        // 处理生产商的逻辑，使用 inforList
        plantInfo.value = data.inforList.isInfo
    }
}

const clearForm = () => {
    authForm.companyName = "",
        authForm.companyAddress = "",
        authForm.establishedTime = "",
        authForm.staffNumber = 1,
        authForm.businessType = "",
        authForm.productType = "",
        authForm.marketType = "",
        authForm.marketChannel = "",
        authForm.businessContact = "",
        authForm.businessContactDuty = "",
        authForm.businessContactPhone = "",
        authForm.annualSalesNum = "",
        authForm.annualSales = "",
        authForm.desiredProcessingMode = "",
        authForm.principalMarket = "",
        authForm.briefIntroduction = "",
        facForm.plantName = "",
        facForm.plantAddress = "",
        facForm.establishedTime = "",
        facForm.staffNumber = 1,
        facForm.plantArea = "",
        facForm.productionLineNum = "",
        facForm.processingCategory = "",
        facForm.annualSalesNum = "",
        facForm.annualSales = "",
        facForm.orderType = "",
        facForm.principalMarket = "",
        facForm.tailorNum = 0,
        facForm.workNum = 0,
        facForm.packagingNum = 0,
        facForm.qualityNum = 0,
        facForm.businessContact = "",
        facForm.businessContactPhone = "",
        facForm.businessContactEmail = "",
        facForm.businessContactWx = "",
        facForm.businessContactQq = ""
}
const authForm = reactive({
    companyName: "",
    companyAddress: "",
    establishedTime: "",
    staffNumber: 1,
    businessType: "",
    productType: "",
    marketType: "",
    marketChannel: "",
    businessContact: "",
    businessContactDuty: "",
    businessContactPhone: "",
    annualSalesNum: "",
    annualSales: "",
    desiredProcessingMode: "",
    principalMarket: "",
    briefIntroduction: "",
    businessLicense: "",
})

const clientAuth = () => {
    let obj = {
        companyName: authForm.companyName,
        companyAddress: authForm.companyAddress,
        establishedTime: authForm.establishedTime,
        staffNumber: authForm.staffNumber,
        businessType: authForm.businessType.join(","),
        productType: authForm.productType,
        marketType: authForm.marketType.join(","),
        marketChannel: authForm.marketChannel.join(","),
        annualSalesNum: authForm.annualSalesNum,
        annualSales: authForm.annualSales,
        desiredProcessingMode: authForm.desiredProcessingMode.join(","),
        principalMarket: authForm.principalMarket,
        businessContact: authForm.businessContact,
        businessContactDuty: authForm.businessContactDuty,
        businessContactPhone: authForm.businessContactPhone,
        briefIntroduction: authForm.briefIntroduction,
        businessLicense: authForm.businessLicense
    }
    completeInformation(obj).then(res => {
        if (res.data.code == 200) {
            ElMessage.success("申请成功，请等待审核完成")
            factoryDialog.value = false
            clearForm()
            location.reload()
        }
    })
}

const facForm = reactive({
    plantName: "",
    plantAddress: "",
    establishedTime: "",
    staffNumber: 1,
    plantArea: "",
    productionLineNum: "",
    processingCategory: "",
    annualSalesNum: "",
    annualSales: "",
    orderType: "",
    principalMarket: "",
    plantIntroduce: "",
    businessLicense: "",
    // plantLogo:"",
    picture: [],
    tailorNum: 0,
    workNum: 0,
    packagingNum: 0,
    qualityNum: 0,
    businessContact: "",
    businessContactPhone: "",
    businessContactEmail: "",
    businessContactWx: "",
    businessContactQq: ""
})

const facAuth = () => {
    let obj = {
        plantName: facForm.plantName,
        plantAddress: facForm.plantAddress,
        establishedTime: facForm.establishedTime,
        // staffNumber: facForm.staffNumber,
        tailorNum: facForm.tailorNum,
        workNum: facForm.workNum,
        packagingNum: facForm.packagingNum,
        qualityNum: facForm.qualityNum,
        plantArea: facForm.plantArea,
        productionLineNum: facForm.productionLineNum,
        processingCategory: facForm.processingCategory,
        annualSalesNum: facForm.annualSalesNum,
        annualSales: facForm.annualSales,
        orderType: facForm.orderType.join(","),
        principalMarket: facForm.principalMarket,
        plantIntroduce: facForm.plantIntroduce,
        businessLicense: facForm.businessLicense,
        // plantLogo:facForm.plantLogo,
        picture: facForm.picture,
        businessContact: facForm.businessContact,
        businessContactPhone: facForm.businessContactPhone,
        businessContactEmail: facForm.businessContactEmail,
        businessContactWx: facForm.businessContactWx,
        businessContactQq: facForm.businessContactQq
    }
    plantInformation(obj).then(res => {
        if (res.data.code == 200) {
            ElMessage.success("申请成功，请等待审核完成")
            kefuDialog.value = false
            clearForm()
            location.reload()
        }
    })
}

//制单文件pdf
const beforeImageUpload = (file) => {
    if (facForm.picture.length >= 10) {
        ElMessage.error('图片数量不能超过 10 张');
        return; // 返回 false 阻止上传
    }
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'; // 验证文件类型是否为 JPG 或 PNG
    const isLt2M = file.size / 1024 / 1024 < 2; // 验证文件大小是否小于 2MB

    if (!isJpgOrPng) {
        ElMessage.error('只能上传 JPG 或 PNG 格式的图片');
    }
    if (!isLt2M) {
        ElMessage.error('图片大小不能超过 2MB');
    }

    return isJpgOrPng && isLt2M; // 返回验证结果，如果通过验证则允许上传，否则阻止上传

}

const handleExceed = (files, fileList) => {
    ElMessage.warning('只能上传一张图片文件');
};

const handleImgExceed = (file, fileList) => {
    ElMessage.warning('图片数量不能超过 10 张');
}




const handlePictureCardPreview = (uploadFile) => {
    dialogVisible.value = true
    dialogImageUrl.value = uploadFile.url
}

const handleRemove = (file) => {
    let index = facForm.picture.findIndex(s => {
        return s.url = file.url
    })
    if (index < 0) return
    facForm.picture.splice(index, 1)
}

const orderContractSuccess = (response, file, fileList) => {
    if (response.code == 200) {
        ElMessage.success('文件上传成功');
        authForm.businessLicense = response.data.url
    }
}

const handleImgSuccess = (response, file, fileList) => {
    if (response.code == 200) {
        ElMessage.success('文件上传成功');
        facForm.picture.push({
            name: response.data.name,
            url: response.data.url
        })
    }
}

const handleSuccess = (response, file, fileList) => {
    if (response.code == 200) {
        ElMessage.success('文件上传成功');
        facForm.businessLicense = response.data.url
    }
}


const kehuBtn = () => {
    kefuDialog.value = true
}

const facBtn = () => {
    factoryDialog.value = true
}


</script>

<style scoped>
.content {
    background: #F8F8F8;
    margin-top: 1.15rem;
    overflow: hidden;
}

.status li {
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    color: #3C3C3C;
    padding-bottom: .1375rem;
    cursor: pointer;
}

.person {
    /* width: 1400px; */
    /* height: 1284px; */
    background: #FFFFFF;
    opacity: 1;
    margin: .125rem 3.25rem;
    overflow: hidden;
}

.perInformation {
    height: 1.1375rem;
    background: #FFFFFF;
    opacity: 1;
    margin: .3rem;
    border: .0125rem solid #DDDDDD;
    display: flex;
    justify-content: space-between;
    line-height: 1.1375rem;
}

.kehuBtn {
    /* width: 136px; */
    height: .6125rem;
    background: #002FA7;
    opacity: 1;
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
}

.facAuth {
    /* width: 136px; */
    height: .6125rem;
    background: #F7B02D;
    opacity: 1;
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
}

.liBox {
    display: flex;
    gap: 1.1125rem;
    margin-left: .3875rem;
}

.liBox li {
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #818AA0;
    cursor: pointer;
}

.active {
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold !important;
    color: #000000 !important;
}

::v-deep .el-dialog__body {
    padding: 0;
}

::v-deep .el-form-item__label {
    font-size: .225rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #000000;
}

::v-deep .el-form {
    display: flex;
    flex-wrap: wrap;
}

::v-deep .el-input {
    width: 3.2875rem;
    height: .65rem;
    background: #FFFFFF;
    opacity: 1;
    border: .0125rem solid #D8D8D8;
}

::v-deep .el-form-item__label {
    font-size: .175rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #333333;
    line-height: .65rem;
}

::v-deep .el-form-item {
    margin-top: .4375rem;
}

.shenqingBtn {
    width: 4.2125rem;
    height: .8rem;
    background: #002FA7;
    opacity: 1;
    font-size: .2375rem;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    margin-top: .375rem;
}

::v-deep .el-dialog__close {
    font-size: .2375rem;
    color: #000000;
    opacity: 1;
}

.uploadBtn {
    width: 1.6375rem;
    height: .475rem;
    background: #002FA7;
    border-radius: .05rem .05rem .05rem .05rem;
    opacity: 1;
    border: .0125rem solid #DDDDDD;
    font-size: .175rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
}

::v-deep .el-form--inline .el-form-item {
    margin-right: .4rem;
}

::v-deep .el-input-number .el-input__wrapper {
    padding-left: .525rem;
    padding-right: .525rem;
}

::v-deep .el-input__inner {
    font-size: .175rem;
}
</style>
